






/*
<header class="page__header">
      <h1 class="page__title">

      </h1>
    </header>
    */
import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";
import Report from "@/components/Report/Report.vue";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteUpdate",
  "beforeRouteLeave"
]);

@Component({
  extends: BaseView,
  components: {
    Report
  }
})
export default class ReportView extends Vue {
  public dirty: boolean = false;

  async beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      const result: Promise<boolean> | boolean = await this.$bvModal
        .msgBoxConfirm("Raport nie został zapisany. Czy kontynuować?", {
          okTitle: "Tak",
          cancelTitle: "Nie"
        })
        .then((value: boolean) => value);
      if (result === true) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
}
